// extracted by mini-css-extract-plugin
export default {"container":"list_container__3OGxv","ordered":"list_ordered__2BxFc","item":"list_item__19GYR","padded":"list_padded__3vVKG"};